// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.university-slider {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 40px 0;
  padding: 0 20px; 
}
.slick-list .university-card {
  
  max-width: 354px; 
}
.slick-track {
  text-align: center;
}
.university-card {
  background: #306dc7;
  border-radius: 10px;
  padding: 30px;
  /* margin-left: 50px; */
  width: 100%;
  max-width: 354px; 
  height: 309px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  flex: 0 0 350px;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #2a2a2a;
  position: relative;
}
.university-card:hover {
  /* transform: translateY(-10px); */
    border-color: #2bb8dd;
    box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);
}

.university-card h3 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.university-card p {
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
  line-height: 1.5; 
}

.university-card .rank {
  font-size: 18px;
  font-weight: bold;
  color: #2596be;
  margin-top: 20px;
}

.university-card a {
  font-size: 16px;
  color: #2596be;
  text-decoration: none;
  border: 1px solid #2596be;
  padding: 10px;
  border-radius: 5px;
  transition: background-color 0.3s ease, color 0.3s ease;
  align-self: flex-start;
}

.university-card a:hover {
  background-color: #2596be;
  color: #fff;
}


.slider-arrows {
  position: absolute;
  top: 50%;
  display: flex;
  justify-content: space-between;
  width: 90%;
  transform: translateY(-50%);
}

.arrow {
  background-color: #2596be;
  color: white;
  font-size: 24px;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  transition: transform 0.3s ease-in-out, background-color 0.3s ease-in-out;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow:hover {
  background-color: #007b8f;
  transform: scale(1.1);
}


@media (max-width: 768px) {
  .university-card {
    width: 100%;
    /* max-width: 300px; */
    height: auto;
  }
  
  .slider-arrows {
    width: 100%;
    gap: 10px;
  }
  
  .arrow {
    font-size: 20px;
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UniversitySlider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yCAAyC;EACzC,mEAAmE;EACnE,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kCAAkC;IAChC,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yEAAyE;EACzE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":[".university-slider {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin: 40px 0;\n  padding: 0 20px; \n}\n.slick-list .university-card {\n  \n  max-width: 354px; \n}\n.slick-track {\n  text-align: center;\n}\n.university-card {\n  background: #306dc7;\n  border-radius: 10px;\n  padding: 30px;\n  /* margin-left: 50px; */\n  width: 100%;\n  max-width: 354px; \n  height: 309px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  flex: 0 0 350px;\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid #2a2a2a;\n  position: relative;\n}\n.university-card:hover {\n  /* transform: translateY(-10px); */\n    border-color: #2bb8dd;\n    box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);\n}\n\n.university-card h3 {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.university-card p {\n  font-size: 16px;\n  color: #555;\n  margin-bottom: 20px;\n  line-height: 1.5; \n}\n\n.university-card .rank {\n  font-size: 18px;\n  font-weight: bold;\n  color: #2596be;\n  margin-top: 20px;\n}\n\n.university-card a {\n  font-size: 16px;\n  color: #2596be;\n  text-decoration: none;\n  border: 1px solid #2596be;\n  padding: 10px;\n  border-radius: 5px;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  align-self: flex-start;\n}\n\n.university-card a:hover {\n  background-color: #2596be;\n  color: #fff;\n}\n\n\n.slider-arrows {\n  position: absolute;\n  top: 50%;\n  display: flex;\n  justify-content: space-between;\n  width: 90%;\n  transform: translateY(-50%);\n}\n\n.arrow {\n  background-color: #2596be;\n  color: white;\n  font-size: 24px;\n  border-radius: 50%;\n  padding: 10px;\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out, background-color 0.3s ease-in-out;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.arrow:hover {\n  background-color: #007b8f;\n  transform: scale(1.1);\n}\n\n\n@media (max-width: 768px) {\n  .university-card {\n    width: 100%;\n    /* max-width: 300px; */\n    height: auto;\n  }\n  \n  .slider-arrows {\n    width: 100%;\n    gap: 10px;\n  }\n  \n  .arrow {\n    font-size: 20px;\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
